module.exports = __webpack_public_path__ + "img/img7.838b54eb.png";